import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n';
import { Home, ArrowLeft, ShieldOff, ServerCrash, FileQuestion } from 'lucide-react';
import { Button } from './ui/button';

const ERRORS = {
  403: { icon: ShieldOff, title: 'Access denied', description: 'You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.' },
  404: { icon: FileQuestion, title: 'Page not found', description: 'The page you are looking for does not exist or has been moved.' },
  500: { icon: ServerCrash, title: 'Server error', description: 'Something went wrong on our end. Please try again later or contact support.' },
};

export default function ErrorPage({ code = 404 }) {
  const { t } = useT();
  const cfg = ERRORS[code] || ERRORS[404];
  const Icon = cfg.icon;
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <Icon className="w-16 h-16 text-muted-foreground/30 mb-4" strokeWidth={1.5} />
      <div className="text-7xl font-bold text-muted-foreground/20 mb-4 font-mono">{code}</div>
      <h1 className="text-2xl font-semibold mb-2">{t(cfg.title)}</h1>
      <p className="text-muted-foreground mb-8 max-w-md">{t(cfg.description)}</p>
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => window.history.back()}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('Go back')}
        </Button>
        <Button asChild>
          <Link to="/dashboard">
            <Home className="w-4 h-4 mr-2" />
            {t('Dashboard')}
          </Link>
        </Button>
      </div>
    </div>
  );
}
